import { Button } from '@cognite/cogs.js';
import styled from 'styled-components/macro';
import {
  rejectButtonBackgroundColor,
  rejectButtonTextColor,
} from 'utils/colors';

interface RejectProcedureButtonProps {
  shouldApplyRejectStyles?: boolean;
}

export const RejectProcedureButton = styled(Button)<RejectProcedureButtonProps>`
  width: max-content;
  margin-right: 10px;
  background-color: ${({ shouldApplyRejectStyles }) =>
    shouldApplyRejectStyles ? rejectButtonBackgroundColor : undefined};
  color: ${({ shouldApplyRejectStyles }) =>
    shouldApplyRejectStyles ? rejectButtonTextColor : undefined};
`;
